var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ssoField"},_vm._l((_vm.listSsoField),function(item){return _c('a-tooltip',{attrs:{"title":`Map ${item} field of user information to this block`,"placement":"leftTop"}},[_c('a-tag',{staticClass:"ssoField__tag",on:{"click":() => _vm.$emit('click', item, _vm.index, _vm.block)}},[_vm._v(_vm._s(item))])],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }